<!-- src/components/Login.vue -->
<template>
  <el-card class="login-card" shadow="hover">
    <h2 style="text-align: center;">律师登录</h2>
    <el-form :model="loginForm" ref="loginFormRef" :rules="rules" label-width="0">
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" placeholder="请输入用户名" clearable></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%;">登录</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import md5 from 'md5'
import Cookies from 'js-cookie'
import config from '@/config'

export default {
  name: 'LawyerLogin',
  setup() {
    const router = useRouter()
    const loginForm = ref({
      username: '',
      password: ''
    })
    const loading = ref(false)
    const loginFormRef = ref(null)
    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    }
    const handleLogin = () => {
      loginFormRef.value.validate(async (valid) => {
        if (!valid) return

        loading.value = true
        try {
          // 调用登录接口
          const response = await axios.post(
            `${config.BASE_URL}/pc/api/login.php`,
            {
              account: loginForm.value.username,
              password: md5(loginForm.value.password) // MD5加密
            }
          )

          if (response.data.code === 200) {
            // 存储登录信息到Cookies
            Cookies.set('user_token', response.data.data.id, { expires: 7 })
            Cookies.set('user_info', JSON.stringify(response.data.data), { expires: 7 })
            
            ElMessage.success(response.data.message)
            router.push('/search')
          } else {
            // 处理不同错误类型
            const errorMessages = {
              400: '请输入完整的账号密码',
              401: '账号或密码错误',
              403: response.data.message,
              500: '服务器错误，请稍后再试'
            }
            ElMessage.error(errorMessages[response.data.code] || '登录失败')
          }
        } catch (error) {
          // 网络错误处理
          if (!error.response) {
            ElMessage.error('网络连接异常，请检查网络')
          } else {
            ElMessage.error('登录失败，请重试')
          }
        } finally {
          loading.value = false
        }
      })
    }

    return {
      loginForm,
      rules,
      loginFormRef,
      loading,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-card {
  max-width: 400px;
  margin: 100px auto;
  padding: 20px;
}
</style>
